export default __webpack_public_path__ + "static/media/gold.80510092.png";